// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
import { combineReducers } from 'redux'
import * as R from 'ramda'
// actions
import {
  SET_LOADED,
  SET_WINDOW_DIMENSION,
  SET_WINDOW_FOCUS,
  SET_PERMISSIONS,
  SET_CONNECTION_STATUS,
  SET_IS_MULTI_TAB,
  SET_SENDFIELD_HEIGHT,
} from './root.action'
// reducers
import appReducer from '../_app/main/app.reducer'
// setup
import { getState } from '$setup/redux'

// TODO add 'waiting for network'
export type ConnectionStatus =
  | 'making ready'
  | 'signing in'
  | 'connecting'
  | 'authenticating'
  | 'updating'
  | 'connected'
  | 'signing out'

interface State {
  connectionStatus: ConnectionStatus
  window: {
    height: number
    width: number
    focus: boolean
  }
  loaded: boolean
  permissions: {
    mic: PermissionState
  }
  isMultiTab: boolean
  sendField: {
    height: number
  }
}

const initialState: State = {
  window: {
    height: 0,
    width: 0,
    focus: true,
  },
  loaded: false,
  permissions: {
    mic: 'denied',
  },
  connectionStatus: 'making ready',
  isMultiTab: false,
  sendField: { height: 55 },
}

// lens
const loadedLens = R.lensProp('loaded')
const windowLens = R.lensProp('window')
const windowFocusLens = R.lensPath(['window', 'focus'])
const permissionsLens = R.lensProp('permissions')
const connectionStatusLens = R.lensProp('connectionStatus')
const sendFieldHeightLens = R.lensPath(['sendField', 'height'])
// views
export const loadedView = () => R.path(['view', 'main', 'loaded'], getState())
export const isMultiTabView = () =>
  R.path(['view', 'main', 'isMultiTab'], getState())
export const windowView = () => R.path(['view', 'main', 'window'], getState())
export const connectionStatusView = () =>
  R.path(['view', 'main', 'connectionStatus'], getState()) as ConnectionStatus
export const windowFocusView = () =>
  R.path(['view', 'main', 'window', 'focus'], getState())
export const micPermissionView = () =>
  R.path(['view', 'main', 'permissions', 'mic'], getState())
export const sendFieldHeightView = () =>
  R.path(['view', 'main', 'sendField', 'height'], getState())
// reducers
const reducers = {
  [SET_WINDOW_DIMENSION]: (state, { width, height }) =>
    R.set(windowLens, { ...state.window, width, height })(state),

  [SET_WINDOW_FOCUS]: (state, { value }) =>
    R.set(windowFocusLens, value)(state),

  [SET_LOADED]: (state, { loaded }) => R.set(loadedLens, loaded)(state),

  [SET_PERMISSIONS]: (state, value) =>
    R.over(permissionsLens, R.mergeDeepLeft(value), state),

  [SET_CONNECTION_STATUS]: (state, value) =>
    R.set(connectionStatusLens, value)(state),

  [SET_IS_MULTI_TAB]: (state, value) => ({ ...state, isMultiTab: value }),

  [SET_SENDFIELD_HEIGHT]: (state, height) =>
    R.set(sendFieldHeightLens, height)(state),
}

const mainReducer = function reducer(state = initialState, action) {
  return reducers[action.type]
    ? reducers[action.type](state, action.payload)
    : state
}

export default combineReducers({
  main: mainReducer,
  app: appReducer,
})
